import { Minus, Plus, X, Trash2, Users, StickyNote, AlertCircle, CornerLeftUp } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import KonumSecici from '@/components/insaat/KonumSecici';
import PozSecici from '@/components/insaat/PozSecici';
import MasrafGrubuSecici from '@/components/insaat/MasrafGrubuSecici';

// Günlük raporun MASAÜSTÜ hali: Excel gibi tek tablo, her iş bir satır
// (kullanıcı, 2026-11-03: liste + yan panel iki ayrı dikey kaydırma
// yaratıyordu). Sütunlar: Tür · Başladı · Poz/İş · Miktar · Birim · Konum 1 ·
// Konum 2 · [Yapan] · Ekip · Saat · Bitti. Tür ve başlangıç ayrı sütunda:
// poz hücresinin üstünde rozet olunca satırlardaki kutular hizasını kaybediyordu. Sayfanın TEK kaydırması vardır; tablo
// kendi içinde kaymaz, başlık satırı yapışık kalır.
//
// EKİP: pozisyonlar açık uçlu (Usta, Kalfa… + "Diğer"le her şey), sabit
// sütunlara sığmaz. Hücre ekibin özetini gösterir ("10 kişi · 3 Usta,
// 7 Düz işçi"); tıklayınca hücrenin altında küçük bir düzenleyici açılır
// (pozisyon + sayı, hızlı ekleme, yukarıdaki son ekibi kopyalama). Sayfa kaymaz.
//
// Mobil düzen (kartlar) PublicDailyReportForm'da; iki düzen aynı satır
// verisini ve aynı doğrulamayı kullanır.

export const POZISYONLAR = ['Usta', 'Kalfa', 'Düz işçi', 'Formen', 'Operatör', 'Mühendis'];
export const kisiSayisi = (ekip) => (ekip || []).reduce((t, e) => t + (parseInt(e.adet, 10) || 0), 0);
const uid = () => Math.random().toString(36).slice(2, 10);
const tarihMetni = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' }) : '');
const tarihKisa = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' }) : '');

const HUCRE = 'h-10 text-sm bg-white border-[#d0c4b0]';
const TH = 'px-2 py-2.5 text-left text-xs font-semibold uppercase tracking-wide text-[#5c554b] bg-[#efe8dc] border-b border-[#d0c4b0]';
const TD = 'px-2 py-2 align-top border-b border-[#e8dfd0]';

function KucukSayac({ deger, onChange, disabled, testId }) {
  const n = parseInt(deger, 10) || 0;
  return (
    <div className="flex items-center rounded-md border border-[#d0c4b0] bg-white overflow-hidden shrink-0">
      <button type="button" disabled={disabled || n <= 0} onClick={() => onChange(Math.max(0, n - 1))} aria-label="Bir azalt"
        className="h-9 w-8 flex items-center justify-center text-[#3F3E39] hover:bg-[#efe8dc] disabled:opacity-40">
        <Minus size={14} />
      </button>
      <input type="number" min="0" value={deger} disabled={disabled} data-testid={testId} aria-label="Kişi sayısı"
        onChange={(e) => onChange(e.target.value)}
        className="h-9 w-11 text-center text-sm font-semibold tabular-nums border-x border-[#e8dfd0] outline-none focus:bg-[#faf7f2]" />
      <button type="button" disabled={disabled} onClick={() => onChange(n + 1)} aria-label="Bir artır"
        className="h-9 w-8 flex items-center justify-center text-[#3F3E39] hover:bg-[#efe8dc] disabled:opacity-40">
        <Plus size={14} />
      </button>
    </div>
  );
}

function EkipHucresi({ r, sira, onceki, oncekiSira, kilitli, hatali, ekipGuncelle, pozisyonEkle }) {
  const ekip = r.ekip || [];
  const toplam = kisiSayisi(ekip);
  const ozet = ekip.filter((e) => parseInt(e.adet, 10) > 0 && (e.pozisyon || '').trim())
    .map((e) => `${e.adet} ${e.pozisyon}`).join(', ');
  const guncelle = (fn) => ekipGuncelle(r.line_id, fn);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" disabled={kilitli && !toplam} data-testid={`ekip-hucre-${sira}`}
          className={`w-full min-h-10 rounded-lg border px-2.5 py-1.5 text-left text-sm transition-colors hover:bg-[#faf7f2]
            ${hatali ? 'border-[#b4442f] bg-[#b4442f]/5' : toplam ? 'border-[#d0c4b0] bg-white' : 'border-dashed border-[#b0a090] bg-white'}`}>
          {toplam ? (
            <>
              <span className="flex items-center gap-1 font-semibold tabular-nums text-[#1a1916]"><Users size={14} /> {toplam} kişi</span>
              <span className="block text-xs leading-snug text-[#5c554b] break-words">{ozet}</span>
            </>
          ) : (
            <span className={`flex items-center gap-1 ${hatali ? 'text-[#b4442f] font-medium' : 'text-[#5c554b]'}`}>
              <Plus size={14} /> Ekip gir
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[360px] p-3 bg-white border-[#d0c4b0]" data-testid={`ekip-duzenle-${sira}`}>
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-semibold text-[#1a1916]">{sira}. iş — çalışan ekip</p>
          <span className="text-sm font-semibold tabular-nums text-[#2e2d29]">{toplam} kişi</span>
        </div>
        {ekip.length === 0 && <p className="text-sm text-[#8a7e70] mb-2">Aşağıdan pozisyon ekleyin.</p>}
        <div className="space-y-1.5">
          {ekip.map((e, j) => (
            <div key={e.id} className="flex items-center gap-2">
              {e.ozel ? (
                <Input value={e.pozisyon} disabled={kilitli} list="pozisyon-onerileri" placeholder="Pozisyon yazın" autoFocus={!e.pozisyon}
                  aria-label="Pozisyon" data-testid={`ekip-poz-${sira}-${j}`}
                  onChange={(ev) => guncelle((x) => x.map((y) => (y.id === e.id ? { ...y, pozisyon: ev.target.value } : y)))}
                  className="h-9 text-sm min-w-0 flex-1 border-[#d0c4b0]" />
              ) : (
                <span className="min-w-0 flex-1 text-sm font-medium text-[#1a1916]" data-testid={`ekip-poz-${sira}-${j}`}>{e.pozisyon}</span>
              )}
              <KucukSayac deger={e.adet} disabled={kilitli} testId={`ekip-adet-${sira}-${j}`}
                onChange={(v) => guncelle((x) => x.map((y) => (y.id === e.id ? { ...y, adet: v } : y)))} />
              {!kilitli && (
                <button type="button" aria-label={`${e.pozisyon || 'satırı'} çıkar`} title="Çıkar"
                  onClick={() => guncelle((x) => x.filter((y) => y.id !== e.id))}
                  className="h-9 w-8 flex items-center justify-center rounded-md text-[#8a7e70] hover:bg-[#7a3535]/10 hover:text-[#7a3535]">
                  <X size={16} />
                </button>
              )}
            </div>
          ))}
        </div>
        {!kilitli && (
          <>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {POZISYONLAR.map((p) => (
                <button key={p} type="button" onClick={() => pozisyonEkle(r.line_id, p)} data-testid={`hizli-${sira}-${p}`}
                  className="h-8 px-2.5 rounded-full border border-[#d0c4b0] bg-white text-xs font-medium text-[#3F3E39] hover:bg-[#efe8dc]">
                  + {p}
                </button>
              ))}
              <button type="button" onClick={() => guncelle((x) => [...x, { id: uid(), pozisyon: '', adet: 1, ozel: true }])}
                className="h-8 px-2.5 rounded-full border border-dashed border-[#b0a090] text-xs text-[#5c554b] hover:bg-[#efe8dc]">
                + Diğer
              </button>
            </div>
            {kisiSayisi(onceki?.ekip) > 0 && (
              <button type="button" data-testid={`ekip-kopyala-${sira}`}
                onClick={() => guncelle(() => onceki.ekip.map((e) => ({ id: uid(), pozisyon: e.pozisyon, adet: e.adet, ozel: e.ozel })))}
                className="mt-3 w-full h-9 rounded-md border border-[#d0c4b0] text-sm text-[#3F3E39] hover:bg-[#efe8dc] flex items-center justify-center gap-1.5">
                <CornerLeftUp size={14} /> {oncekiSira}. işin ekibini al ({kisiSayisi(onceki.ekip)} kişi)
              </button>
            )}
          </>
        )}
      </PopoverContent>
    </Popover>
  );
}

function NotDugmesi({ r, sira, kilitli, isGuncelle }) {
  const dolu = !!(r.aciklama || '').trim();
  if (kilitli && !dolu) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`${sira}. işe açıklama`} title={dolu ? r.aciklama : 'Açıklama ekle'}
          className={`h-9 w-9 flex items-center justify-center rounded-md hover:bg-[#efe8dc] ${dolu ? 'text-[#2e2d29]' : 'text-[#b0a090]'}`}>
          <StickyNote size={16} fill={dolu ? '#efe8dc' : 'none'} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-3 bg-white border-[#d0c4b0]">
        <label className="block text-sm font-medium text-[#3F3E39] mb-1.5" htmlFor={`not-t-${r.line_id}`}>
          Açıklama <span className="font-normal text-[#8a7e70]">(isteğe bağlı)</span>
        </label>
        <Input id={`not-t-${r.line_id}`} value={r.aciklama || ''} disabled={kilitli} autoFocus className={HUCRE}
          onChange={(e) => isGuncelle(r.line_id, { aciklama: e.target.value })} />
      </PopoverContent>
    </Popover>
  );
}

export default function IsTablosu({
  isler, kilitli, hatalar, isBilgileri, kalemHaritasi, isKalemleri, masrafGruplari, siteKonumlari,
  yapanVar, altTaseronlar, subcontractorName, yeniSatir, isGuncelle, isSil, ekipGuncelle, pozisyonEkle, raporTarihi,
}) {
  const konumVar = siteKonumlari.length > 0;
  const sutunSayisi = 10 + (konumVar ? 2 : 0) + (yapanVar ? 1 : 0);

  return (
    <table className="w-full table-fixed border-separate border-spacing-0 rounded-xl border border-[#d0c4b0] bg-white text-sm" data-testid="is-tablosu">
      <colgroup>
        <col className="w-10" />
        <col className="w-[88px]" />
        <col className="w-[104px]" />
        <col />
        <col className="w-[84px]" />
        <col className="w-[72px]" />
        {konumVar && <col className="w-40" />}
        {konumVar && <col className="w-40" />}
        {yapanVar && <col className="w-40" />}
        <col className="w-44" />
        <col className="w-[68px]" />
        <col className="w-14" />
        <col className="w-[76px]" />
      </colgroup>
      <thead>
        <tr>
          <th className={`${TH} sticky top-0 z-10 rounded-tl-xl text-center`}>#</th>
          <th className={`${TH} sticky top-0 z-10`}>Tür</th>
          <th className={`${TH} sticky top-0 z-10`} title="İşin başladığı gün; önceki günlerden devam eden işlerde kaçıncı gün olduğu">Başladı</th>
          <th className={`${TH} sticky top-0 z-10`}>Poz / İş tanımı</th>
          <th className={`${TH} sticky top-0 z-10`}>Miktar</th>
          <th className={`${TH} sticky top-0 z-10`}>Birim</th>
          {konumVar && <th className={`${TH} sticky top-0 z-10`}>Konum 1</th>}
          {konumVar && <th className={`${TH} sticky top-0 z-10`}>Konum 2</th>}
          {yapanVar && <th className={`${TH} sticky top-0 z-10`}>Yapan</th>}
          <th className={`${TH} sticky top-0 z-10`}>Ekip</th>
          <th className={`${TH} sticky top-0 z-10`}>Saat</th>
          <th className={`${TH} sticky top-0 z-10 text-center`} title="İşaretlenmeyen iş yarınki formunuza kendiliğinden gelir">Bitti</th>
          <th className={`${TH} sticky top-0 z-10 rounded-tr-xl`}><span className="sr-only">İşlemler</span></th>
        </tr>
      </thead>
      <tbody>
        {isler.length === 0 && (
          <tr>
            <td colSpan={sutunSayisi} className="px-4 py-10 text-center text-sm text-[#5c554b]">
              Henüz iş eklenmedi. Tablonun altındaki düğmelerle satır ekleyin.
            </td>
          </tr>
        )}
        {isler.map((r, i) => {
          const sira = i + 1;
          const k = kalemHaritasi[r.kalem_id];
          const kayip = r.tur === 'poz' && r.kalem_id && !k;
          const hata = hatalar[r.line_id];
          const devam = r.is_id ? isBilgileri[r.is_id] : null;
          const sabit = kilitli || !!devam;
          const birim = r.tur === 'poz' ? (k?.birim || r.birim) : r.birim;
          const hataSinifi = hata ? 'bg-[#b4442f]/[0.04]' : '';
          // Ekip kopyalama için yukarıdaki son ekipli satır
          const onceki = isler.slice(0, i).reverse().find((x) => kisiSayisi(x.ekip) > 0);
          return [
            <tr key={r.line_id} id={`is-${r.line_id}`} data-testid={`is-satir-${sira}`} className={`scroll-mt-16 ${hataSinifi}`}>
              <td className={`${TD} text-center ${hata ? 'border-l-4 border-l-[#b4442f]' : ''}`}>
                <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[#2e2d29]/10 text-xs font-semibold tabular-nums text-[#2e2d29] mt-1.5">
                  {sira}
                </span>
              </td>
              <td className={TD}>
                <span className={`mt-2.5 inline-block rounded-full px-2 py-0.5 text-xs ${r.tur === 'poz' ? 'bg-[#2e2d29]/10 text-[#2e2d29]' : 'bg-[#7a6a2e]/15 text-[#5c4f22]'}`}>
                  {r.tur === 'poz' ? 'Sözleşmeli' : 'İlave'}
                </span>
              </td>
              <td className={TD}>
                {/* Devam eden iş: ilk günü ve kaçıncı gün; yeni iş bugün başlıyor */}
                {devam && devam.gun_no > 1 ? (
                  <span className="block pt-1 leading-tight" data-testid={`devam-rozet-${sira}`}
                    title={`${tarihMetni(devam.baslangic)} tarihinde başladı · şimdiye kadar ${devam.onceki_adam_gun || 0} adam·gün`}>
                    <span className="block text-sm font-semibold tabular-nums text-[#1a1916]">{tarihKisa(devam.baslangic)}</span>
                    <span className="block whitespace-nowrap text-xs font-medium text-[#24557a]">Devam · {devam.gun_no}. gün</span>
                  </span>
                ) : (
                  <span className="block pt-1 leading-tight">
                    <span className="block text-sm tabular-nums text-[#5c554b]">{tarihKisa(devam?.baslangic || raporTarihi)}</span>
                    <span className="block text-xs text-[#8a7e70]">Yeni iş</span>
                  </span>
                )}
              </td>
              <td className={TD}>
                {r.tur === 'poz' ? (
                  <PozSecici kompakt kalemler={isKalemleri} value={kayip ? '' : r.kalem_id} disabled={sabit} sira={sira}
                    onChange={(v) => isGuncelle(r.line_id, { kalem_id: v })}
                    kayipMetni={kayip ? `${r.poz_no || ''} ${r.is_cinsi || ''}`.trim() : null}
                    testId={`poz-sec-${sira}`} />
                ) : (
                  <div className="space-y-1.5">
                    <Input disabled={sabit} value={r.is_cinsi} placeholder="İş tanımı" aria-label={`${sira}. iş tanımı`}
                      autoFocus={yeniSatir === r.line_id} className={HUCRE} data-testid={`ilave-is-${sira}`}
                      onChange={(e) => isGuncelle(r.line_id, { is_cinsi: e.target.value })} />
                    <MasrafGrubuSecici kompakt gruplar={masrafGruplari} value={r.masraf_grubu_id} disabled={sabit}
                      hatali={hata === 'İşin grubunu seçin'} baslik={`${sira}. iş — iş grubunu seçin`}
                      onChange={(v) => isGuncelle(r.line_id, { masraf_grubu_id: v })} testId={`masraf-sec-${sira}`} />
                  </div>
                )}
              </td>
              <td className={TD}>
                <Input type="number" inputMode="decimal" step="any" min="0" disabled={kilitli} value={r.miktar}
                  placeholder={r.tamamlandi ? '' : 'bitince'} aria-label={`${sira}. iş miktarı`}
                  title={r.tamamlandi ? 'Yapılan miktar' : 'Metraj iş bitince girilir; şimdi boş bırakabilirsiniz'}
                  onChange={(e) => isGuncelle(r.line_id, { miktar: e.target.value })}
                  className={`${HUCRE} tabular-nums text-right px-2`} data-testid={`miktar-${sira}`} />
                {devam?.onceki_miktar > 0 && (
                  <span className="block mt-1 text-[11px] text-[#8a7e70] tabular-nums">önceki: {devam.onceki_miktar}</span>
                )}
              </td>
              <td className={TD}>
                {r.tur === 'poz' ? (
                  <span className="block pt-2.5 text-sm text-[#5c554b]">{birim || '—'}</span>
                ) : (
                  <Input disabled={kilitli} value={r.birim} placeholder="m2…" aria-label={`${sira}. iş birimi`}
                    onChange={(e) => isGuncelle(r.line_id, { birim: e.target.value })} className={`${HUCRE} px-2`} />
                )}
              </td>
              {konumVar && (
                <td className={TD}>
                  <KonumSecici kompakt adim={1} konumlar={siteKonumlari} value={r.konum_id} yol={r.konum_yolu} disabled={sabit}
                    onChange={(v) => isGuncelle(r.line_id, { konum_id: v })} testId={`konum1-${sira}`} />
                </td>
              )}
              {konumVar && (
                <td className={TD}>
                  <KonumSecici kompakt adim={2} konumlar={siteKonumlari} value={r.konum_id} yol={r.konum_yolu} disabled={sabit}
                    onChange={(v) => isGuncelle(r.line_id, { konum_id: v })} testId={`konum2-${sira}`} />
                </td>
              )}
              {yapanVar && (
                <td className={TD}>
                  <select value={r.alt_taseron_id || ''} disabled={kilitli} aria-label={`${sira}. işi yapan`}
                    onChange={(e) => isGuncelle(r.line_id, { alt_taseron_id: e.target.value || null })}
                    className="w-full h-10 px-2 rounded-md border border-[#d0c4b0] bg-white text-sm text-[#1a1916] disabled:opacity-60">
                    <option value="">{subcontractorName} (kendimiz)</option>
                    {r.alt_taseron_id && !altTaseronlar.some((a) => a.id === r.alt_taseron_id) && (
                      <option value={r.alt_taseron_id} disabled>{r.alt_taseron_adi} (pasif — yenisini seçin)</option>
                    )}
                    {altTaseronlar.map((a) => <option key={a.id} value={a.id}>{a.ad}</option>)}
                  </select>
                </td>
              )}
              <td className={TD}>
                <EkipHucresi r={r} sira={sira} onceki={onceki} oncekiSira={onceki ? isler.indexOf(onceki) + 1 : 0} kilitli={kilitli}
                  hatali={!!hata && /ekip/i.test(hata)} ekipGuncelle={ekipGuncelle} pozisyonEkle={pozisyonEkle} />
              </td>
              <td className={TD}>
                <Input type="number" inputMode="decimal" step="0.5" min="0" max="24" value={r.saat ?? ''} disabled={kilitli}
                  aria-label={`${sira}. iş çalışma saati`} title="Bugün kaç saat çalışıldı?"
                  onChange={(e) => isGuncelle(r.line_id, { saat: e.target.value })}
                  className={`${HUCRE} tabular-nums text-right px-2`} data-testid={`saat-${sira}`} />
              </td>
              <td className={`${TD} text-center`}>
                <input type="checkbox" checked={!!r.tamamlandi} disabled={kilitli} data-testid={`tamamlandi-${sira}`}
                  aria-label={`${sira}. iş tamamlandı`}
                  title={r.tamamlandi ? 'İş kapanır' : 'İşaretlemezseniz bu iş yarın formunuza kendiliğinden gelir'}
                  onChange={(e) => isGuncelle(r.line_id, { tamamlandi: e.target.checked })}
                  className="mt-2.5 h-5 w-5 cursor-pointer accent-[#3d6e4e]" />
              </td>
              <td className={TD}>
                <div className="flex items-center justify-end">
                  <NotDugmesi r={r} sira={sira} kilitli={kilitli} isGuncelle={isGuncelle} />
                  {!kilitli && (
                    <button type="button" onClick={() => isSil(r.line_id)} aria-label={`${sira}. işi sil`} title="İşi sil"
                      className="h-9 w-9 flex items-center justify-center rounded-md text-[#8a7e70] hover:bg-[#7a3535]/10 hover:text-[#7a3535]">
                      <Trash2 size={16} />
                    </button>
                  )}
                </div>
              </td>
            </tr>,
            hata && (
              <tr key={`${r.line_id}-hata`} className="bg-[#b4442f]/[0.04]">
                <td colSpan={sutunSayisi} className="px-3 pb-2 pt-0 border-b border-[#e8dfd0] border-l-4 border-l-[#b4442f]">
                  <p role="alert" className="flex items-center gap-1.5 text-sm font-medium text-[#b4442f]">
                    <AlertCircle size={14} className="shrink-0" /> {sira}. iş: {hata}
                  </p>
                </td>
              </tr>
            ),
          ];
        })}
      </tbody>
    </table>
  );
}
